import { ref, computed } from "vue";

const inputInvalid = ref(false);

const useInputValidationStore = () => {
    const isInputInvalid = computed(() => inputInvalid.value);

    const setInputInvalid = (value: boolean) => {
        inputInvalid.value = value;
    };

    return {
        isInputInvalid,
        setInputInvalid,
    };
};

export default useInputValidationStore;
